// extracted by mini-css-extract-plugin
export default {"response":"utils_response__ERVJ9"};